function updateDispatchTime() {
    const picker = document.querySelector('hdt-variant-picker');
    const dispatch = document.getElementById('dispatch-time');

    if (!picker || !dispatch || !window.productDispatchTimes) return;

    const variantId = picker.getAttribute('selected-variant');

    if (window.productDispatchTimes[variantId]) {
        dispatch.textContent = window.productDispatchTimes[variantId];
    }
}

// Initial load
document.addEventListener("DOMContentLoaded", updateDispatchTime);

// Watch for selected-variant attribute changes
const observer = new MutationObserver(function () {
    updateDispatchTime();
});

document.addEventListener("DOMContentLoaded", function () {
    const picker = document.querySelector("hdt-variant-picker");
    if (picker) {
        observer.observe(picker, {
            attributes: true,
            attributeFilter: ["selected-variant"]
        });
    }
});